// ========================================
// 🎯 ACTION TYPES
// ========================================

export const UPDATE_SIDEBAR_MENU = 'UPDATE_SIDEBAR_MENU';

export const GET_SIDEBAR_MENU_REQUEST = 'GET_SIDEBAR_MENU_REQUEST';
export const GET_SIDEBAR_MENU_SUCCESS = 'GET_SIDEBAR_MENU_SUCCESS';
export const GET_SIDEBAR_MENU_FAIL = 'GET_SIDEBAR_MENU_FAIL';

export const GET_ALL_SIDEBAR_MENUS_REQUEST = 'GET_ALL_SIDEBAR_MENUS_REQUEST';
export const GET_ALL_SIDEBAR_MENUS_SUCCESS = 'GET_ALL_SIDEBAR_MENUS_SUCCESS';
export const GET_ALL_SIDEBAR_MENUS_FAIL = 'GET_ALL_SIDEBAR_MENUS_FAIL';

export const GET_ORDERED_SIDEBAR_MENUS_REQUEST = 'GET_ORDERED_SIDEBAR_MENUS_REQUEST';
export const GET_ORDERED_SIDEBAR_MENUS_SUCCESS = 'GET_ORDERED_SIDEBAR_MENUS_SUCCESS';
export const GET_ORDERED_SIDEBAR_MENUS_FAIL = 'GET_ORDERED_SIDEBAR_MENUS_FAIL';

export const GET_SIDEBAR_MENUS_BY_ROLE_REQUEST = 'GET_SIDEBAR_MENUS_BY_ROLE_REQUEST';
export const GET_SIDEBAR_MENUS_BY_ROLE_SUCCESS = 'GET_SIDEBAR_MENUS_BY_ROLE_SUCCESS';
export const GET_SIDEBAR_MENUS_BY_ROLE_FAIL = 'GET_SIDEBAR_MENUS_BY_ROLE_FAIL';

export const GET_SIDEBAR_MENUS_BY_STATUS_REQUEST = 'GET_SIDEBAR_MENUS_BY_STATUS_REQUEST';
export const GET_SIDEBAR_MENUS_BY_STATUS_SUCCESS = 'GET_SIDEBAR_MENUS_BY_STATUS_SUCCESS';
export const GET_SIDEBAR_MENUS_BY_STATUS_FAIL = 'GET_SIDEBAR_MENUS_BY_STATUS_FAIL';

export const GET_ROOT_SIDEBAR_MENUS_REQUEST = 'GET_ROOT_SIDEBAR_MENUS_REQUEST';
export const GET_ROOT_SIDEBAR_MENUS_SUCCESS = 'GET_ROOT_SIDEBAR_MENUS_SUCCESS';
export const GET_ROOT_SIDEBAR_MENUS_FAIL = 'GET_ROOT_SIDEBAR_MENUS_FAIL';

export const GET_CHILD_SIDEBAR_MENUS_REQUEST = 'GET_CHILD_SIDEBAR_MENUS_REQUEST';
export const GET_CHILD_SIDEBAR_MENUS_SUCCESS = 'GET_CHILD_SIDEBAR_MENUS_SUCCESS';
export const GET_CHILD_SIDEBAR_MENUS_FAIL = 'GET_CHILD_SIDEBAR_MENUS_FAIL';

export const CREATE_SIDEBAR_MENU_REQUEST = 'CREATE_SIDEBAR_MENU_REQUEST';
export const CREATE_SIDEBAR_MENU_SUCCESS = 'CREATE_SIDEBAR_MENU_SUCCESS';
export const CREATE_SIDEBAR_MENU_FAIL = 'CREATE_SIDEBAR_MENU_FAIL';

export const UPDATE_SIDEBAR_MENU_REQUEST = 'UPDATE_SIDEBAR_MENU_REQUEST';
export const UPDATE_SIDEBAR_MENU_SUCCESS = 'UPDATE_SIDEBAR_MENU_SUCCESS';
export const UPDATE_SIDEBAR_MENU_FAIL = 'UPDATE_SIDEBAR_MENU_FAIL';

export const DELETE_SIDEBAR_MENU_REQUEST = 'DELETE_SIDEBAR_MENU_REQUEST';
export const DELETE_SIDEBAR_MENU_SUCCESS = 'DELETE_SIDEBAR_MENU_SUCCESS';
export const DELETE_SIDEBAR_MENU_FAIL = 'DELETE_SIDEBAR_MENU_FAIL';

export const SET_SIDEBAR_MENU_LOADING = 'SET_SIDEBAR_MENU_LOADING';



export const GET_SIDEBAR_MENUS_BY_ROLE_ADMIN_REQUEST = "GET_SIDEBAR_MENUS_BY_ROLE_ADMIN_REQUEST";
export const GET_SIDEBAR_MENUS_BY_ROLE_ADMIN_SUCCESS = "GET_SIDEBAR_MENUS_BY_ROLE_ADMIN_SUCCESS";
export const GET_SIDEBAR_MENUS_BY_ROLE_ADMIN_FAIL = "GET_SIDEBAR_MENUS_BY_ROLE_ADMIN_FAIL";


// ========================================
// 🎬 ACTION CREATORS
// ========================================

export const updateSidebarMenu = (menu) => {
    return {
        type: UPDATE_SIDEBAR_MENU,
        menu
    };
}

// --- Récupérer un menu par ID ---
export const getSidebarMenuRequest = (menuId) => ({
    type: GET_SIDEBAR_MENU_REQUEST,
    payload: { menuId }
});

export const getSidebarMenuSuccess = (menu) => ({
    type: GET_SIDEBAR_MENU_SUCCESS,
    payload: menu
});

export const getSidebarMenuFail = (error) => ({
    type: GET_SIDEBAR_MENU_FAIL,
    error
});

// --- Récupérer tous les menus ---
export const getAllSidebarMenusRequest = () => ({
    type: GET_ALL_SIDEBAR_MENUS_REQUEST
});

export const getAllSidebarMenusSuccess = (menus) => ({
    type: GET_ALL_SIDEBAR_MENUS_SUCCESS,
    payload: menus
});

export const getAllSidebarMenusFail = (error) => ({
    type: GET_ALL_SIDEBAR_MENUS_FAIL,
    error
});

// --- Récupérer les menus ordonnés ---
export const getOrderedSidebarMenusRequest = () => ({
    type: GET_ORDERED_SIDEBAR_MENUS_REQUEST
});

export const getOrderedSidebarMenusSuccess = (menus) => ({
    type: GET_ORDERED_SIDEBAR_MENUS_SUCCESS,
    payload: menus
});

export const getOrderedSidebarMenusFail = (error) => ({
    type: GET_ORDERED_SIDEBAR_MENUS_FAIL,
    error
});

// -----Récuperer les menus chez admin

export const getSidebarMenusByRoleAdminRequest = (companyId,roleId) => ({
    type: GET_SIDEBAR_MENUS_BY_ROLE_ADMIN_REQUEST,
    payload: { companyId, roleId }
});
export const getSidebarMenusByRoleAdminSuccess = (menus) => ({
    type: GET_SIDEBAR_MENUS_BY_ROLE_ADMIN_SUCCESS,
    payload: menus
});
export const getSidebarMenusByRoleAdminFail = (error) => ({
    type: GET_SIDEBAR_MENUS_BY_ROLE_ADMIN_FAIL,
    error
});


// --- Récupérer les menus par rôle ---
export const getSidebarMenusByRoleRequest = (companyId,roleId) => ({
    type: GET_SIDEBAR_MENUS_BY_ROLE_REQUEST,
    payload: { companyId, roleId }
});

export const getSidebarMenusByRoleSuccess = (menus, roleId) => ({
    type: GET_SIDEBAR_MENUS_BY_ROLE_SUCCESS,
    payload: menus,
    meta: { roleId }
});

export const getSidebarMenusByRoleFail = (error) => ({
    type: GET_SIDEBAR_MENUS_BY_ROLE_FAIL,
    error
});

// --- Récupérer les menus par statut ---
export const getSidebarMenusByStatusRequest = (status) => ({
    type: GET_SIDEBAR_MENUS_BY_STATUS_REQUEST,
    payload: { status }
});

export const getSidebarMenusByStatusSuccess = (menus) => ({
    type: GET_SIDEBAR_MENUS_BY_STATUS_SUCCESS,
    payload: menus
});

export const getSidebarMenusByStatusFail = (error) => ({
    type: GET_SIDEBAR_MENUS_BY_STATUS_FAIL,
    error
});

// --- Récupérer les menus racines ---
export const getRootSidebarMenusRequest = () => ({
    type: GET_ROOT_SIDEBAR_MENUS_REQUEST
});

export const getRootSidebarMenusSuccess = (menus) => ({
    type: GET_ROOT_SIDEBAR_MENUS_SUCCESS,
    payload: menus
});

export const getRootSidebarMenusFail = (error) => ({
    type: GET_ROOT_SIDEBAR_MENUS_FAIL,
    error
});

// --- Récupérer les menus enfants ---
export const getChildSidebarMenusRequest = (parentId) => ({
    type: GET_CHILD_SIDEBAR_MENUS_REQUEST,
    payload: { parentId }
});

export const getChildSidebarMenusSuccess = (menus) => ({
    type: GET_CHILD_SIDEBAR_MENUS_SUCCESS,
    payload: menus
});

export const getChildSidebarMenusFail = (error) => ({
    type: GET_CHILD_SIDEBAR_MENUS_FAIL,
    error
});

// --- Créer un menu ---
export const createSidebarMenuRequest = (menuData, history) => ({
    type: CREATE_SIDEBAR_MENU_REQUEST,
    payload: menuData,
    history
});

export const createSidebarMenuSuccess = (menu) => ({
    type: CREATE_SIDEBAR_MENU_SUCCESS,
    payload: menu
});

export const createSidebarMenuFail = (error) => ({
    type: CREATE_SIDEBAR_MENU_FAIL,
    error
});

// --- Mettre à jour un menu ---
export const updateSidebarMenuRequest = (menuId, menuData) => ({
    type: UPDATE_SIDEBAR_MENU_REQUEST,
    payload: { menuId, menuData }
});

export const updateSidebarMenuSuccess = (menu) => ({
    type: UPDATE_SIDEBAR_MENU_SUCCESS,
    payload: menu
});

export const updateSidebarMenuFail = (error) => ({
    type: UPDATE_SIDEBAR_MENU_FAIL,
    error
});

// --- Supprimer un menu ---
export const deleteSidebarMenuRequest = (menuId, history) => ({
    type: DELETE_SIDEBAR_MENU_REQUEST,
    payload: { menuId },
    history
});

export const deleteSidebarMenuSuccess = (menuId) => ({
    type: DELETE_SIDEBAR_MENU_SUCCESS,
    payload: { menuId }
});

export const deleteSidebarMenuFail = (error) => ({
    type: DELETE_SIDEBAR_MENU_FAIL,
    error
});

// --- Loading ---
export const setSidebarMenuLoading = (loading) => ({
    type: SET_SIDEBAR_MENU_LOADING,
    payload: loading
});
